var map = {
	"./CircleShape/Attr": [
		3980,
		774,
		780
	],
	"./Group/Attr": [
		9379,
		774,
		697
	],
	"./LineShape/Attr": [
		4466,
		774,
		370
	],
	"./Picture/Attr": [
		544,
		774,
		944
	],
	"./RectShape/Attr": [
		1529,
		774,
		879
	],
	"./VButton/Attr": [
		8479,
		774,
		733
	],
	"./VChart/Attr": [
		9012,
		774,
		344,
		676
	],
	"./VTable/Attr": [
		2782,
		774,
		358
	],
	"./VText/Attr": [
		2598,
		774,
		6
	],
	"./svgs/SVGStar/Attr": [
		6575,
		774,
		677
	],
	"./svgs/SVGTriangle/Attr": [
		9715,
		774,
		313
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1302;
module.exports = webpackAsyncContext;